import { Link } from 'react-router-dom';
import { forumCategories, featuredArticles } from '@/mocks/forumData';

export default function HomePage() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '草榴论坛入口指南',
    url: window.location.origin,
    description: '草榴论坛官方入口与使用指南，提供最新入口地址、注册教程、版块介绍及安全使用指南。',
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '草榴论坛入口指南',
    url: window.location.origin,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${window.location.origin}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '如何找到草榴论坛最新入口地址？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过本站首页获取最新入口地址，或关注草榴论坛官方社交媒体账号获取实时更新。本站将持续更新和维护最新的入口信息。',
        },
      },
      {
        '@type': 'Question',
        name: '草榴论坛注册需要什么条件？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '注册草榴论坛需要一个有效的电子邮箱地址，按照注册页面提示填写用户名和密码即可完成注册。详细教程请参考本站的注册教程文章。',
        },
      },
      {
        '@type': 'Question',
        name: '草榴论坛有哪些主要版块？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '草榴论坛设有综合交流、技术讨论、资源分享、新人专区、休闲娱乐和社区公告等主要版块。每个版块有明确的主题定位和使用规范。',
        },
      },
      {
        '@type': 'Question',
        name: '使用草榴论坛需要注意什么安全问题？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '建议使用强密码保护账号，不在公开帖子中透露个人敏感信息，定期更新密码，并避免在公共网络环境下登录论坛。详细安全指南请参考本站相关文章。',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20amber%20and%20cream%20tones%2C%20flowing%20organic%20shapes%2C%20minimalist%20modern%20design%2C%20clean%20aesthetic%2C%20subtle%20texture%2C%20no%20text%2C%20no%20people%2C%20editorial%20style%20with%20gentle%20color%20transitions&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
              alt="草榴论坛入口指南背景"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
          </div>

          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-3xl mx-auto">
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
                草榴论坛 - 官方入口与使用指南
              </h1>
              <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed max-w-2xl mx-auto">
                草榴论坛是知名的综合交流社区。本页为您提供草榴论坛的最新入口地址、注册登录方法、版块介绍及安全使用指南，帮助用户快速找到并顺利访问草榴论坛的全部功能。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/xinren-zhuanqu"
                  className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                    <i className="ri-guide-line text-sm"></i>
                  </span>
                  查看新手教程
                </Link>
                <Link
                  to="/category/zonghe-jiaoliu"
                  className="px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white border border-white/25 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  浏览论坛版块
                  <span className="w-4 h-4 inline-flex items-center justify-center ml-2">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Bar */}
        <section className="w-full bg-background-50 border-b border-background-200/70">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
              {[
                { label: '论坛版块', value: '6+', icon: 'ri-layout-grid-line' },
                { label: '活跃会员', value: '50,000+', icon: 'ri-user-star-line' },
                { label: '精华文章', value: '3,200+', icon: 'ri-star-line' },
                { label: '持续更新', value: '每日', icon: 'ri-refresh-line' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${stat.icon} text-lg`}></i>
                  </div>
                  <div className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Category Cards */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                论坛版块导航
              </h2>
              <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                草榴论坛设有以下主要版块，每个版块都有明确的主题定位。选择感兴趣的版块开始探索吧。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {forumCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-all duration-200 cursor-pointer"
                >
                  <div className={`w-11 h-11 flex items-center justify-center rounded-lg mb-4 ${
                    cat.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                    cat.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                    'bg-secondary-100 text-secondary-600'
                  }`}>
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                    {cat.description}
                  </p>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-article-line text-xs"></i>
                    </span>
                    <span>{cat.articleCount.toLocaleString()} 篇文章</span>
                    <span className="text-foreground-300">·</span>
                    <span className="text-primary-500 group-hover:translate-x-0.5 transition-transform duration-200 whitespace-nowrap">
                      浏览版块 <i className="ri-arrow-right-s-line text-xs"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                  精选教程文章
                </h2>
                <p className="text-sm text-foreground-600">
                  整理最实用的草榴论坛使用教程，帮助新手快速上手
                </p>
              </div>
              <Link
                to="/category/xinren-zhuanqu"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                查看全部 <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.slice(0, 6).map((article) => {
                const cat = forumCategories.find((c) => c.slug === article.category);
                return (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
                  >
                    <div className="relative h-44 overflow-hidden">
                      <img
                        src={article.thumbnail}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                      />
                      <div className="absolute top-3 left-3">
                        <span className="px-2.5 py-1 bg-primary-500 text-white text-xs rounded-md font-medium whitespace-nowrap">
                          {cat?.name || article.category}
                        </span>
                      </div>
                    </div>
                    <div className="p-4 md:p-5">
                      <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                        {article.title}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center justify-between text-xs text-foreground-500">
                        <div className="flex items-center gap-3">
                          <span className="flex items-center gap-1">
                            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-eye-line text-xs"></i></span>
                            {article.viewCount.toLocaleString()}
                          </span>
                          <span className="flex items-center gap-1">
                            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-chat-3-line text-xs"></i></span>
                            {article.commentCount}
                          </span>
                        </div>
                        <span className="text-foreground-400">{article.publishDate}</span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>

            <div className="mt-8 text-center sm:hidden">
              <Link
                to="/category/xinren-zhuanqu"
                className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                查看全部教程 <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
              </Link>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                常见问题解答
              </h2>
              <p className="text-sm text-foreground-600">
                以下是关于草榴论坛使用过程中最常被问到的问题
              </p>
            </div>

            <div className="space-y-3">
              {[
                {
                  q: '如何找到草榴论坛最新入口地址？',
                  a: '您可以通过本站首页获取最新入口地址信息。我们持续关注草榴论坛的域名变化，并及时更新。建议收藏本站以便随时获取最新入口信息。',
                },
                {
                  q: '草榴论坛注册需要什么条件？',
                  a: '注册草榴论坛需要一个有效的电子邮箱地址。按照注册页面提示填写用户名和密码，完成邮箱验证后即可激活账号。',
                },
                {
                  q: '草榴论坛有哪些主要版块？',
                  a: '草榴论坛设有综合交流、技术讨论、资源分享、新人专区、休闲娱乐和社区公告等六大主要版块。每个版块有明确的主题定位和使用规范，您可以根据兴趣选择浏览。',
                },
                {
                  q: '如何保证账号安全？',
                  a: '建议使用12位以上的强密码，包含大小写字母、数字和特殊符号。定期更换密码，不在公共设备上保存密码，不向他人透露账号信息。如论坛支持，务必开启二次验证。',
                },
                {
                  q: '遇到访问问题怎么办？',
                  a: '首先检查网络连接是否正常，尝试清除浏览器缓存和DNS缓存。如果仍然无法访问，可以尝试使用论坛的备用域名，或通过本站获取最新入口地址。',
                },
              ].map((faq, index) => (
                <details key={index} className="group bg-background-100 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer">
                  <summary className="flex items-center justify-between px-5 py-4 list-none">
                    <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4 cursor-pointer">
                      {faq.q}
                    </h3>
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500 group-open:rotate-45 transition-transform duration-200">
                      <i className="ri-add-line"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="w-full py-14 md:py-20 bg-primary-500">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
              准备好探索草榴论坛了吗？
            </h2>
            <p className="text-sm md:text-base text-white/85 mb-8 max-w-xl mx-auto">
              从新手教程开始，了解论坛的注册流程、版块设置和使用技巧，快速融入这个充满活力的社区。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/xinren-zhuanqu"
                className="px-8 py-3.5 bg-white text-primary-600 hover:bg-background-100 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                开始学习
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 bg-primary-600 hover:bg-primary-700 text-white rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}